"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeployProgressMessage = exports.Constants = void 0;
const localizeUtils_1 = require("../../../../../common/localizeUtils");
class Constants {
}
exports.Constants = Constants;
Constants.APP_CATALOG_REFRESH_TIME = 20000;
Constants.APP_CATALOG_MAX_TIMES = 6;
Constants.APP_CATALOG_ACTIVE_TIME = 180000;
Constants.DeployDriverName = "spfx/deploy";
Constants.TelemetryComponentName = "fx-resource-spfx";
Constants.TelemetryDeployEventName = "deploy";
Constants.DeployProgressTitle = () => localizeUtils_1.getLocalizedString("plugins.spfx.deploy.title");
Constants.DevProgramLink = "https://developer.microsoft.com/en-us/microsoft-365/dev-program";
class DeployProgressMessage {
}
exports.DeployProgressMessage = DeployProgressMessage;
DeployProgressMessage.SkipCreateSPAppCatalog = () => localizeUtils_1.getLocalizedString("driver.spfx.deploy.skipCreateAppCatalog");
DeployProgressMessage.CreateSPAppCatalog = () => localizeUtils_1.getLocalizedString("driver.spfx.deploy.createAppCatalog");
DeployProgressMessage.Upload = () => localizeUtils_1.getLocalizedString("driver.spfx.deploy.uploadPackage");
DeployProgressMessage.Deploy = () => localizeUtils_1.getLocalizedString("driver.spfx.deploy.deployPackage");
//# sourceMappingURL=constants.js.map